<template>
  <div>
    <!-- Title Bar -->
    <div class="has-background-white rounded-lg px-lg py-md mb-xxs">
      <div class="columns is-vcentered is-mobile">
        <div class="column">
          <div class="has-text-weight-bold is-size-7">
            <p v-if="context.isMerchant()">PRODUCT SKUs & OFFERS</p>
            <p v-else>PRODUCT SKUs</p>
          </div>
        </div>
        <div class="column is-one-third has-text-right">
          <b-field class="is-pulled-right">
            <b-radio-button v-model="view" size="is-small" native-value="offers">Pricing</b-radio-button>
            <b-radio-button v-model="view" size="is-small" native-value="inventory">Inventory</b-radio-button>
            <!-- <b-radio-button v-model="view" size="is-small" native-value="attributes">Attributes</b-radio-button>
            <b-radio-button v-model="view" size="is-small" native-value="images">Images</b-radio-button> -->
          </b-field>
        </div>
      </div>
    </div>
    <!-- Variant List -->
    <div class="has-background-white rounded-lg">
      <div>
        <b-table
          :data="variants"
          :mobile-cards="false"
          :loading="loading || variants.length === 0"
          striped
          class="is-tall is-size-7">
          <template>
            <!-- Identifiers -->
            <b-table-column
              label="Product"
              cell-class="nowrap"
              v-slot="props">
              <Identifiers
                :variant="props.row"
                :showImage="true"
                nameInteraction="none"
                imageInteraction="none"
                @inspect="inspectVariant"
                @navigate="navigateToDetail"
              ></Identifiers>
            </b-table-column>
            <!-- Cost -->
            <b-table-column
              label="Cost"
              :visible="columns.includes('offers')"
              header-class="nowrap is-hidden-mobile"
              cell-class="nowrap is-hidden-mobile"
              centered
              width="110"
              v-slot="props">
              <p v-if="props.row.active_permit.retailer_cost !== null">{{ $numbers(props.row.active_permit.retailer_cost).formatCurrency({ mantissa: 2 }) }}</p>
              <p v-else class="has-text-grey-light">External</p>
            </b-table-column>
            <!-- Price -->
            <b-table-column
              label="Retail"
              :visible="columns.includes('offers')"
              header-class="nowrap is-hidden-mobile"
              cell-class="nowrap is-hidden-mobile"
              centered
              width="110"
              v-slot="props">
              <p v-if="props.row.active_permit.retailer_price !== null">{{ $numbers(props.row.active_permit.retailer_price).formatCurrency({ mantissa: 2 }) }}</p>
              <p v-else class="has-text-grey-light">External</p>
            </b-table-column>
            <!-- Start Date -->
            <b-table-column
              label="Effective"
              :visible="columns.includes('offers')"
              header-class="nowrap is-hidden-mobile"
              cell-class="nowrap is-hidden-mobile"
              centered
              width="110"
              v-slot="props">
              <p v-if="props.row.active_permit.start_at !== null">{{ $dates.utc(props.row.active_permit.start_at).local().format('MMM D, YYYY') }}</p>
              <p v-else class="has-text-grey-light">Now</p>
            </b-table-column>
            <!-- End Date -->
            <b-table-column
              label="Ends"
              :visible="columns.includes('offers')"
              header-class="nowrap is-hidden-mobile"
              cell-class="nowrap is-hidden-mobile"
              centered
              width="110"
              v-slot="props">
              <p v-if="props.row.active_permit.end_at !== null">{{ $dates.utc(props.row.active_permit.end_at).local().format('MMM D, YYYY') }}</p>
              <p v-else class="has-text-grey-light">Never</p>
            </b-table-column>
            <!-- Submitted -->
            <!-- <b-table-column
              label="Submitted"
              :visible="columns.includes('inventory')"
              centered
              width="128"
              v-slot="props">
              <p v-if="props.row.inventory.inventory_last_submitted_at !== null">
                {{ $dates.utc(props.row.inventory.inventory_last_submitted_at).format('MMM D, YYYY') }}
              </p>
              <p v-else><i class="has-text-grey-light">Never</i></p>
            </b-table-column> -->
            <!-- Updated -->
            <b-table-column
              label="Last Updated"
              :visible="columns.includes('inventory')"
              centered
              width="128"
              v-slot="props">
              <p v-if="props.row.inventory.inventory_updated_at !== null">
                {{ $dates.utc(props.row.inventory.inventory_updated_at).local().format('MMM D, YYYY') }}
                <br/>
                <span class="has-text-grey is-size-8">
                  {{ $dates.utc(props.row.inventory.inventory_updated_at).local().format('h:mm A') }}
                </span>
              </p>
              <p v-else><i class="has-text-grey-light">Never</i></p>
            </b-table-column>
            <!-- Availability -->
            <b-table-column
              label="Availability"
              :visible="columns.includes('inventory')"
              cell-class="nowrap"
              centered
              width="200"
              v-slot="props">
              <div v-if="props.row.inventory.discontinued_updated_at">
                <p class="has-text-weight-bold has-text-centered has-text-danger">Discontinued</p>
                <p class="has-text-grey is-size-8">{{ $dates.utc(props.row.discontinued_updated_at).local().format('MMM D, YYYY') }}</p>
              </div>
              <div v-else-if="props.row.inventory.inventory === 0 && props.row.inventory.estimated_availability_date === null">
                <p class="has-text-weight-bold has-text-centered has-text-danger">0</p>
                <p class="has-text-grey is-size-8">Unknown Return</p>
              </div>
              <div v-else-if="props.row.inventory.inventory === 0 && props.row.inventory.estimated_availability_date !== null">
                <p class="has-text-weight-bold has-text-centered has-text-danger">0</p>
                <p class="has-text-grey is-size-8">Returns {{ $dates.utc(props.row.inventory.estimated_availability_date).local().format('MMM D, YYYY') }}</p>
              </div>
              <div v-else-if="props.row.inventory.inventory > 0">
                <p class="has-text-weight-bold">
                  <span v-if="props.row.inventory.inventory === 9999" class="has-text-grey is-italic">Not Managed</span>
                  <span v-else>{{ props.row.inventory.inventory }}</span>
                </p>
                <p class="has-text-grey is-size-8">Available Now</p>
              </div>
            </b-table-column>
          </template>
          <template #empty>
            <div class="py-xxl has-text-grey has-text-centered">
              {{ (loading) ? "Loading data..." : 'No variants found!' }}
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CdnTransform from '@/mixins/CdnTransform'
import Identifiers from '@/components/Models/Variant/Identifiers'
export default {
  components: {
    Identifiers
  },
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return this.context.route + '/products/' + this.product.id + '/variants/'
    },
    columns () {
      if (this.view === 'offers') return ['sku', 'offers']
      if (this.view === 'inventory') return ['sku', 'inventory']
      return ['sku']
    }
  },
  data () {
    return {
      loading: true,
      view: 'offers',
      variants: [],
      selected: [],
      detail: null
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$http.get(this.endpoint).then(response => {
        const variants = response.data.results
        if (variants.length) {
          this.variants = variants.filter(variant => variant.active_permit !== null)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    editVariants (field) {
      this.showVariantEditModal = true
      this.editField = field
    },
    inspectVariant (variant) {
      this.detail = variant
    },
    navigateToDetail (variant) {
      this.$router.push({ name: 'catalog.item', params: { id: variant.product_id, item: variant.id } })
    }
  },
  mounted () {
    this.load()
  },
  mixins: [CdnTransform],
  props: ['product']
}
</script>
